export enum PlatformEnum {
  Web = 'Web',
  Android = 'Android',
  Ios = 'Ios'
}
